import script from "./BatchUpdPostNo.vue?vue&type=script&setup=true&lang=js"
export * from "./BatchUpdPostNo.vue?vue&type=script&setup=true&lang=js"

import "./BatchUpdPostNo.vue?vue&type=style&index=0&id=6d9c60bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d9c60bc"]])

export default __exports__